import { useMyOrganization } from './useMyOrganization'

/**
 * Har aktiv organisasjon tilbudsmodulen (Tilbud og Katalog)?
 *
 * Organisasjonens egen bryter, `organizations.offers_enabled`, satt av eier eller admin under
 * Innstillinger → Organisasjon. Uten organisasjon, eller før svaret er inne, er modulen på:
 * standarden for alle kunder er uendret, og menyen skal ikke blinke bort for dem som har den.
 * Rutevakten venter likevel på `loading`, så en direkte URL ikke slipper gjennom i mellomtiden.
 */
export function useOffersModule(): { enabled: boolean; loading: boolean } {
  const { active, loading } = useMyOrganization()
  return { enabled: active?.org.offers_enabled !== false, loading }
}
